import Cookies from 'js-cookie';
import { COOKIES } from '@config/cookiesConfig';
import axiosService from '@services/axiosService';

const userEndpointPrefix = '/api/AppUser';

export const getUserInfo = (token, userId) => {
  return axiosService.get(`${userEndpointPrefix}/${userId}?access_token=${token}`);
};

export const getEditUser = (token, userId) => {
  return axiosService.get(`${userEndpointPrefix}/${userId}/roles?access_token=${token}`);
};

export const serverLogout = (token, userId) => {
  return axiosService.post(`${userEndpointPrefix}/logout?access_token=${token}`);
};

export const resetUserPassword = (token, userId, newPassword) => {
  const data = {
    newPassword,
  };
  return axiosService.post(
    `${userEndpointPrefix}/${userId}/change-password?access_token=${token}`,
    data,
  );
};

export const requestForResetUserPasswordByEmail = (email) => {
  const data = {
    email,
  };
  return axiosService.post(`${userEndpointPrefix}/reset`, JSON.stringify(data));
};

export const postLoginToAPI = ({ email, password }) => {
  const bodydata = JSON.stringify({
    email,
    password,
    ttl: (COOKIES.EXPIRY * 86400).toString(),
  });
  return axiosService.post(`${userEndpointPrefix}/login`, bodydata);
};

// Cookies handlers
export const removeCredentials = () => {
  Cookies.remove('userId');
  Cookies.remove('token');
  Cookies.remove('mfa_token');
};

export const setCredentials = (userId, token) => {
  Cookies.set('userId', userId, { expires: COOKIES.EXPIRY });
  Cookies.set('token', token, { expires: COOKIES.EXPIRY });
};

export const getUserId = () => !!Cookies.get('userId') && Cookies.get('userId');
export const getToken = () => !!Cookies.get('token') && Cookies.get('token');

export const setOTP = (otp) => {
  // Cookies.set('otp', otp, {expires: COOKIES.OTP_EXPIRY})
};

export const getOTP = () => Cookies.get('otp');

export const requestNewOTP = ({ uuid, id, token }) => {
  return uuid
    ? axiosService.get(`/api/SmsCodes/request-code-by-user?token=${uuid}`)
    : axiosService.get(
        `/api/SmsCodes/request-code-by-user?access_token=${token}&transcriptId=${id}`,
      );
};



// WEBPACK FOOTER //
// ./services/authenticationResource.js